import { render, staticRenderFns } from "./formResetPassword.vue?vue&type=template&id=9adcc6fc"
import script from "./formResetPassword.vue?vue&type=script&lang=js"
export * from "./formResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports